import { L10n } from '../L10n/L10n';
import { FlowListItemInfo } from '../models/FlowInfo';
import { IErrorItem, MultipleItemResult } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { IError } from '../ServerApi/types/IError';
import { IResult } from '../ServerApi/types/IResponse';
import {
  ContentActionNotification,
  IMultipleResultNotificationOptions,
  MultipleResultNotificationOptions,
} from './ContentActionNotification';

// need flow error codes
// Notification For:
// => deleting flows

export class DeleteFlowsActionNotification {

  public static $inject = [
    '$state',
    '$translate',
    'ContentActionNotification'];

  constructor(
    private $state: ng.ui.IStateService,
    private $translate: ng.translate.ITranslateService,
    private contentActionNotification: ContentActionNotification) { }

  public notify(
    result: IResult,
    flows: Set<FlowListItemInfo>) {

    // create a notification object for result reporting
    const notification: IMultipleResultNotificationOptions = MultipleResultNotificationOptions.create(
      new MultipleItemResult(flows, result),
      {
        describeSuccessSummary: (successCount: number) => {
          if (flows.size() === 1) {
            return this.$translate.instant('deleteSingleFlowSuccess', { FLOW_NAME: L10n.elideIfLong(flows.first().name) });
          } else {
            return this.$translate.instant('deleteMultipleFlowsSuccess', { FLOWS_COUNT: successCount}, L10n.Interpolations.Count);
          }
        },
        describeErrorSummary: (errorCount: number) => {
          if (flows.size() === 1) {
            return this.$translate.instant('deleteSingleFlowError', { FLOW_NAME: L10n.elideIfLong(flows.first().name) });
          } else {
            return this.$translate.instant('deleteMultipleFlowsError', { FLOWS_COUNT: errorCount}, L10n.Interpolations.Count);
          }
        },
        describeErrorDetail: (errorItem: IErrorItem<FlowListItemInfo>) => {
          return {
            itemName: errorItem.item.name,
            itemUrl: this.$state.href('main.site.content.flow', { id: errorItem.item.id }),
            errorMessage: this.errorMessageFor(errorItem.error, errorItem.item.name)
          };
        }
      }
    );

    // pass the notification object to the service for displaying
    this.contentActionNotification.notify(notification);
  }


  private errorMessageFor(error: IError, flowName: string) {
    switch (error.code) {
      // TODO: need Flow API specific error codes
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('DeleteFlowsActionNotification', DeleteFlowsActionNotification);
